import {createApp} from 'vue';
import {createPinia} from 'pinia';
import main from './main.vue';
import {useTabs} from '@utils/tabs';

useTabs();

const pinia = createPinia();

createApp(main)
  .use(pinia)
  .mount("#js-configurator-app");